<template>
  <div>
    <nav-list></nav-list>

    <!-- 验证码验证弹窗 -->
    <Modal v-model="showCaptchaModal" title="安全验证" :mask-closable="false" :closable="false" width="400">
      <div class="captcha-modal-content">
        <p>为了您的账号安全，请先完成人机验证</p>
        <div class="captcha-modal-image">
          <img :src="captchaImage" alt="验证码" v-if="captchaImage">
        </div>
        <div class="captcha-input-wrapper">
          <input type="text" v-model="captchaCode" placeholder="请输入验证码" maxlength="4" @keyup.enter="confirmCaptcha">
          <span class="refresh-btn" @click="refreshCaptcha">刷新</span>
        </div>
      </div>
      <div slot="footer" class="captcha-modal-footer">
        <Button type="primary" @click="confirmCaptcha">确认</Button>
        <Button @click="cancelCaptcha">取消</Button>
      </div>
    </Modal>

    <!-- 主要内容 -->
    <div class="dowebok" id="dowebok" :class="rightpanelactive ? 'right-panel-active' : ''">
      <div class="form-container sign-up-container">
        <form action="#">
          <h1 style="margin-bottom: 20px;">注册</h1>
          <div class="social-container">
            <!-- <a href="" class="lbtn btn-1"><img src="../assets/images/qqico.png" width="25"></a> -->
            <!-- <a href="#" class="lbtn btn-1"><img src="../assets/images/wbico.png" width="30"></a> -->
            <!-- <a href="#" class="lbtn btn-1"><img src="../assets/images/wxico.png" width="30"></a> -->
          </div>
          <!-- <span>或使用邮箱注册</span> -->
          <div class="register-ipt"><input type="text" v-model="loginName" placeholder="账号名称" @blur="checkName"></div>
          <div class="register-ipt flex"><input type="text" v-model="mobileNum" placeholder="手机号" maxlength="11">
            <div class="shou" @click="sendcode">发送验证码</div>

          </div>
          <div class="register-ipt"><input type="text" v-model="code" placeholder="验证码"></div>
          <div class="register-ipt"><input type="password" v-model="passWord" placeholder="密码"></div>
          <div class="zsyy flex flex-x-s"><input class="mr-1011" type="checkbox" :checked="isRead"
              @change="changeread">我同意并遵守<router-link :to="{ path: 'about?id=12&name=版权声明' }">《图片安徽网站服务协议》</router-link>
          </div>
          <div @click="sureRegister" class="button">注册</div>
        </form>
      </div>
      <div class="form-container sign-in-container">
        <form action="#">
          <h1 style="margin-bottom: 20px;">登录</h1>
          <div class="social-container">
            <!-- <a href="javascript:;" class="lbtn btn-1"><img src="../assets/images/qqico.png" width="25"></a> -->
            <!-- <a href="#" class="lbtn btn-1"><img src="../assets/images/wbico.png" width="30"></a> -->
            <a href="javascript:;" @click="authorization('WeiXin')" class="lbtn btn-1"><img
                src="../assets/images/wxico.png" width="30"></a>
          </div>

          <!-- <span>或使用您的帐号</span> -->
          <div class="register-ipt"><input type="text" v-model="loginName1" placeholder="账号"></div>
          <div class="register-ipt"><input type="password" v-model="passWord1" placeholder="密码"></div>
          <!-- 四位随机验证码 -->
          <!-- <div class="captcha-container">
            <input type="text" v-model="captchaCode" placeholder="验证码" class="captcha-input" maxlength="4">
            <div class="captcha-image" @click="refreshCaptcha">
              <img :src="captchaImage" alt="验证码" v-if="captchaImage">
            </div>
          </div>
          <div class="captcha-refresh" @click="refreshCaptcha">点击刷新</div> -->


          <router-link class="forget" to="/forget">忘记密码？</router-link>
          <div class="button mt-20" @click="sureLogin">登录</div>
        </form>
      </div>
      <div class="overlay-container">
        <div class="overlay">
          <div class="overlay-panel overlay-left">
            <img src="../assets/images/logo1.png" style="margin-bottom:20px;">
            <h1>已有帐号？</h1>
            <p>请使用您的帐号进行登录</p>
            <button class="ghost button" id="signIn" @click="changeLogin(false)">登录</button>
          </div>
          <div class="overlay-panel overlay-right">
            <img src="../assets/images/logo1.png" style="margin-bottom:20px;">
            <h1>没有帐号？</h1>
            <p>立即注册加入图片安徽，千万正版素材。</p>
            <button class="ghost button" id="signUp" @click="changeLogin(true)">注册</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import navList from './header_nav.vue'
export default {
  data() {
    return {
      rightpanelactive: false,
      sencKey: "", // 加密秘钥
      isCrypt: 0, // 是否加密
      loginName: "",
      mobileNum: "",
      code: "",
      passWord: "",
      isRead: false,
      loginName1: "",
      passWord1: "",
      captchaCode: "", // 验证码输入值
      captchaText: "", // 验证码实际值
      captchaImage: "", // 验证码图片
      showCaptchaModal: false, // 是否显示验证码弹窗
      isCodeSending: false, // 是否正在发送验证码（防抖）
      codeCountdown: 0, // 验证码发送倒计时
      codeTimer: null, // 倒计时定时器

    }
  },

  components: {
    navList
  },

  created() {
    this.isenCrypt() // 是否加密
    this.generateCaptcha() // 生成验证码
  },

  methods: {
    changeLogin(state) {
      this.loginName = ''
      this.mobileNum = ''
      this.code = ''
      this.passWord = ''
      this.rightpanelactive = state
    },

    // 检车是否开启加密
    async isenCrypt() {
      let _this = this
      const res = await _this.get('/user/getPlatConfig.do', { appID: 1, project: "是否开启加密", item: "IS_ENCRYPTION" })
      _this.isCrypt = res.data
      if (res.data == 1) {
        _this.getsencKey() // 如果加密需要
      }
    },

    // 获取加密秘钥
    async getsencKey() {
      let _this = this
      const res = await _this.get('/getPublishKey.do')
      _this.sencKey = res.data
    },

    // 失去焦点验证名称是否可用
    async checkName() {
      let _this = this
      if (_this.loginName == '') {
        return
      }
      const res = await _this.get('/user/checkUserInfo.do', { checkText: _this.loginName, checkType: 1 })

      if (res.result == 1) {
        this.$Message.success({
          content: res.data,
          duration: 3
        });
      }
      if (res.result == 0) {
        this.$Message.error({
          content: res.error.errorMsg,
          duration: 5,
          closable: true
        });
      }
    },

    // 发送验证吗 - 验证手机号
    async sendcode() {
      let _this = this

      // 防抖：检查是否正在发送验证码
      // if (_this.isCodeSending) {
      //   return;
      // }

      // 检查手机号格式
      if (!_this.util.isMobile(_this.mobileNum)) {
        return _this.$Message.error('请输入正确手机号')
      }

      // 检查手机号是否已注册
      var res = await _this.get('/user/checkUserInfo.do', { checkText: _this.mobileNum, checkType: 3 })
      if (res.result == 0) {
        return _this.$Message.error({
          content: res.error.errorMsg,
          duration: 5,
          closable: true
        });
      } else if (res.result == 1) {
        // // 设置防抖状态
        // _this.isCodeSending = true;
        // _this.codeCountdown = 60; // 设置60秒倒计时

        // // 开始倒计时
        // _this.startCountdown();

        // 显示验证码弹窗
        _this.showCaptchaModal = true;
        // 重置验证码
        _this.captchaCode = '';
        _this.generateCaptcha();
      }


    },

    // 开始倒计时
    startCountdown() {
      let _this = this;
      _this.codeTimer = setInterval(() => {
        _this.codeCountdown--;
        if (_this.codeCountdown <= 0) {
          clearInterval(_this.codeTimer);
          _this.isCodeSending = false;
        }
      }, 1000);
    },

    // 确认验证码弹窗
    confirmCaptcha() {
      let _this = this;

      // 检查验证码输入
      if (_this.captchaCode.trim() === '') {
        _this.$Message.error({
          content: '请输入验证码',
          duration: 3
        });
        return;
      }

      // 验证验证码
      if (_this.captchaCode.toUpperCase() !== _this.captchaText) {
        _this.$Message.error({
          content: '验证码错误，请重新输入',
          duration: 3
        });
        _this.refreshCaptcha(); // 刷新验证码
        return;
      }

      // 验证码正确，关闭弹窗
      _this.showCaptchaModal = false;

      // 发送短信验证码
      _this.sendSMSCode();
    },

    // 取消验证码弹窗
    cancelCaptcha() {
      let _this = this;
      _this.showCaptchaModal = false;
      // 取消倒计时
      // if (_this.codeTimer) {
      // clearInterval(_this.codeTimer);
      // _this.isCodeSending = false;
      // }
    },

    // 发送短信验证码
    async sendSMSCode() {
      let _this = this;
      const res1 = await _this.get('/user/sendMobileMessage1.do', { mobileNum: _this.mobileNum, isRegister: true })
      if (res1.result == 1) {
        this.$Message.success({
          content: '发送成功，请等待短信提示',
          duration: 3
        });
      } else {
        // 发送失败，重置防抖状态
        // if (_this.codeTimer) {
        //   clearInterval(_this.codeTimer);
        //   _this.isCodeSending = false;
        // }
      }
    },

    // 确认注册
    async sureRegister() {
      let _this = this
      // 校验账号名称必填
      if (_this.loginName == '') {
        return this.$Message.error('请输入账号名称')
      }
      // 校验手机号必填
      if (_this.mobileNum == '') {
        return this.$Message.error('请输入手机号')
      }
      // 校验验证码必填
      if (_this.code == '') {
        return this.$Message.error('请输入验证码')
      }
      // 校验密码是否包含英文+数字+特殊字符
      const passwordValidation = _this.validatePassword(_this.passWord);
      if (!passwordValidation.isValid) {
        return this.$Message.error({
          content: '密码不符合要求：' + passwordValidation.errors.join('，'),
          duration: 5,
          closable: true
        });
      }

      let { code, loginName, passWord, mobileNum } = _this
      const res = await _this.get('/user/checkCodeAndLogin.do', { isRegister: true, code, loginName, passWord, mobileNum })
      if (res.result == 1) {
        this.$Message.success({
          content: res.data,
          duration: 3
        });
        setTimeout(() => {
          window.location.reload()
        }, 3000)
      }
      if (res.result != 1) {
        this.$Message.error({
          content: res.error.errorMsg || '请求出错',
          duration: 5,
          closable: true
        });
      }
    },

    // 改变阅读协议状态
    changeread(e) {
      // console.log()
      this.isRead = e.target.checked
    },

    // 校验密码是否包含英文+数字+特殊字符
    validatePassword(password) {
      // 检查是否包含英文字母（大小写）
      const hasLetter = /[a-zA-Z]/.test(password);
      // 检查是否包含数字
      const hasNumber = /[0-9]/.test(password);
      // 检查是否包含特殊字符
      const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
      // 检查密码长度
      const isValidLength = password.length >= 6;

      // 验证结果和提示信息
      const errors = [];
      if (!isValidLength) {
        errors.push('密码长度至少6位');
      }
      if (!hasLetter) {
        errors.push('密码必须包含英文字母');
      }
      if (!hasNumber) {
        errors.push('密码必须包含数字');
      }
      if (!hasSpecialChar) {
        errors.push('密码必须包含特殊字符');
      }

      return {
        isValid: errors.length === 0,
        errors: errors
      };
    },

    // 确认登录
    async sureLogin() {
      let _this = this
      // 校验账号名称必填
      if (_this.loginName1 == '') {
        return this.$Message.error('请输入账号名称')
      }
      // 校验密码必填
      if (_this.passWord1 == '') {
        return this.$Message.error('请输入密码')
      }
      // 验证验证码
      // if (_this.captchaCode.trim() === '') {
      //   _this.$Message.error({
      //     content: '请输入验证码',
      //     duration: 3
      //   });
      //   return;
      // }

      // if (_this.captchaCode.toUpperCase() !== _this.captchaText) {
      //   _this.$Message.error({
      //     content: '验证码错误，请重新输入',
      //     duration: 3
      //   });
      //   _this.refreshCaptcha(); // 刷新验证码
      //   return;
      // }

      _this.$Spin.show()
      let data = {
        loginName: _this.loginName1,
        password: _this.passWord1,
        flag: 'pc'
      }
      const res = await _this.post('/loginNew.do', data)
      _this.$Spin.hide()
      if (res.result == 1) {
        this.$Message.success({
          content: "登录成功",
          duration: 3
        });

        localStorage.setItem('token', res.token)
        localStorage.setItem('authorStatus', res.data.authorStatus)
        setTimeout(() => {
          _this.$router.replace({ path: '/index' })
        }, 3000)
      }
      if (res.result == 0) {
        this.$Message.error({
          content: res.error.errorMsg,
          duration: 5,
          closable: true
        });
      }
    },

    // 授权登录
    // http://www.tpahw.com
    async authorization(loginType) {
      let _this = this
      let data = {
        loadingUrl: encodeURI(_this.$baseURL + '/addPhone'),
        loginType,
      }
      const res = await _this.post('/v2/auth/authUrl.do', data)
      window.location.href = res.data.data
    },

    // 生成四位随机验证码
    generateCaptcha() {
      // 定义验证码字符集（排除易混淆的字符如0、O、1、I等）
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      let captcha = '';
      for (let i = 0; i < 4; i++) {
        captcha += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      // 保存验证码实际值（不区分大小写）
      this.captchaText = captcha;

      // 创建canvas绘制验证码
      const canvas = document.createElement('canvas');
      canvas.width = 120;
      canvas.height = 40;
      const ctx = canvas.getContext('2d');

      // 绘制背景
      ctx.fillStyle = '#f0f0f0';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制干扰线
      for (let i = 0; i < 4; i++) {
        ctx.beginPath();
        ctx.strokeStyle = this.randomColor();
        ctx.lineWidth = 1;
        ctx.moveTo(
          Math.random() * canvas.width,
          Math.random() * canvas.height
        );
        ctx.lineTo(
          Math.random() * canvas.width,
          Math.random() * canvas.height
        );
        ctx.stroke();
      }

      // 绘制干扰点
      for (let i = 0; i < 30; i++) {
        ctx.beginPath();
        ctx.fillStyle = this.randomColor();
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          Math.random() * 2,
          0,
          Math.PI * 2
        );
        ctx.fill();
      }

      // 绘制验证码文字
      ctx.font = '24px Arial';
      ctx.fillStyle = '#333';
      for (let i = 0; i < captcha.length; i++) {
        ctx.save();
        ctx.translate(30 * i + 10, 25);
        ctx.rotate(Math.random() * 0.5 - 0.25);
        ctx.fillText(captcha[i], 0, 0);
        ctx.restore();
      }

      // 将canvas转为图片
      this.captchaImage = canvas.toDataURL('image/png');
    },

    // 随机颜色生成器
    randomColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgb(${r},${g},${b})`;
    },

    // 刷新验证码
    refreshCaptcha() {
      this.captchaCode = '';
      this.generateCaptcha();
    },
  },

}
</script>

<style lang="less" scoped>
.forget {
  margin: 2px auto;
  color: #000FFF !important;
}

* {
  box-sizing: border-box;
}

body {
  font-family: 'Montserrat', sans-serif;
  background: #f6f5f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;

}

h1 {
  font-weight: bold;
  margin: 0;
}

p {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: .5px;
  margin: 20px 0 30px;
}

span {
  font-size: 12px;
}

a {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
}

.dowebok {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, .25), 0 10px 10px rgba(0, 0, 0, .22);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  width: 768px;
  max-width: 100%;
  min-height: 480px;
}

.form-container form {
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.social-container {
  margin: 20px 0;
}

.social-container a {

  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  height: 55px;
  width: 55px;
}

.social-container a:hover {
  background-color: #eee;
}

.form-container .register-ipt {
  background: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
  outline: none;
  display: flex;
}

.form-container .register-ipt input {
  flex: 1;
}

.button {
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background: #ff4b2b;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  cursor: pointer;
}

button:active {
  transform: scale(.95);
}

button:focus {
  outline: none;
}

button.ghost {
  background: transparent;
  border-color: #fff;
}

.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all .6s ease-in-out;
}

.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}

.sign-up-container {
  left: 0;
  width: 50%;
  z-index: 1;
  opacity: 0;
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform .6s ease-in-out;
  z-index: 100;
}

.overlay {
  background: #1495f0;
  background: linear-gradient(to right, #086db4, #2fa0ef) no-repeat 0 0 / cover;
  color: #fff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateY(0);
  transition: transform .6s ease-in-out;
}

.overlay-panel {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  height: 100%;
  width: 50%;
  text-align: center;
  transform: translateY(0);
  transition: transform .6s ease-in-out;
}

.overlay-right {
  right: 0;
  transform: translateY(0);
}

.overlay-left {
  transform: translateY(-20%);
}

/* Move signin to right */
.dowebok.right-panel-active .sign-in-container {
  transform: translateY(100%);
}

/* Move overlay to left */
.dowebok.right-panel-active .overlay-container {
  transform: translateX(-100%);
}

/* Bring signup over signin */
.dowebok.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
}

/* Move overlay back to right */
.dowebok.right-panel-active .overlay {
  transform: translateX(50%);
}

/* Bring back the text to center */
.dowebok.right-panel-active .overlay-left {
  transform: translateY(0);
}

/* Same effect for right */
.dowebok.right-panel-active .overlay-right {
  transform: translateY(20%);
}

.lbtn {
  float: left;
  height: 30px;
  line-height: 30px;
  padding: 0 10px;
  background: #00a1d6;
  box-shadow: 0 4px 4px rgba(127, 127, 127, .3);
  display: inline-block;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  transition: all 0.2s;
  margin: 0 0 5px 15px;
}

.btn-1:hover {
  background: #00b5e5;
  text-decoration: none;
}

.btn-2:hover {
  filter: brightness(1.1);
}

/*白色背景的头部*/
.header.on {
  background: #fff;
  border-bottom: 1px solid #ccc;
}

.header.on .left .img1 {
  display: none;
}

.header.on .left .img2 {
  display: block;
}

.header.on .navbar_nav li a {
  color: #333;
}

.header.on .navbar_nav li:hover a {
  color: orangered;
}

.mr-1011 {
  margin: 0 6px 0 0 !important;
}

.footer {
  font-size: 12px;
  color: #999999;
  margin-top: 50px;
  text-align: center;
  line-height: 25px;
}

.captcha-container {

  background: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
  outline: none;
  display: flex;
}

.captcha-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
}

.captcha-image {
  width: 120px;
  height: 40px;
  cursor: pointer;
  margin-left: 10px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
}

.captcha-image img {
  max-width: 100%;
  max-height: 100%;
}

.captcha-refresh {
  width: 100%;
  text-align: right;
  color: #007bff;
  cursor: pointer;
  font-size: 12px;
  margin-top: 5px;
}

/* 验证码弹窗样式 */
.captcha-modal-content {
  padding: 20px;
  text-align: center;
}

.captcha-modal-content p {
  margin-bottom: 15px;
  color: #666;
}

.captcha-modal-image {
  margin: 20px auto;
  width: 120px;
  height: 40px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f0f0f0;
  cursor: pointer;
}

.captcha-modal-image img {
  max-width: 100%;
  max-height: 100%;
}

.captcha-input-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.captcha-input-wrapper input {
  width: 70%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
}

.captcha-input-wrapper input:focus {
  border-color: #007bff;
}

.refresh-btn {
  margin-left: 10px;
  color: #007bff;
  cursor: pointer;
  white-space: nowrap;
}

.captcha-modal-footer {
  text-align: center;
}

.captcha-modal-footer .ivu-btn {
  margin: 0 5px;
}
</style>
